<template>
  <div class="container container--narrow application-residents">

    <div class="application-section-bg mb-ts-2">
      <div class="">
        <h2 class="h3">
          {{translate('Muut asumaan tulevat')}}
        </h2>
      </div>

    <ApplicationAddable
      v-bind="$attrs"
      :text-add="empty ? translate('Lisää hakija') : null"
      :text-item="translate('asukas')"
      :max="8"
      :interactive="!preview"
      @update="$emit('update', $event)"
    >
      <template #title="{index}">
        {{`${index + 1}. ${translate('Asukkaan tiedot')}`}}
      </template>

      <template #default="{index: i, item}">
        <!-- Guard against item not being ready -->
        <div v-if="!item" class="form form--bg-lighter-green">
          <div class="form__title-wrapper">
            <div class="form__title">
              <p>{{ translate('Ladataan...') }}</p>
            </div>
          </div>
        </div>
        <div v-else class="form form--bg-lighter-green">
          <div class="form__grid">
            <div class="form__row">
              <InputWrap
                class="form__col-4"
                :label="translate('Etunimet')"
                :validations="safeVIter(i).FirstName"
                v-slot="{error, touch}"
              >
                <InputText
                  v-model="item.FirstName"
                  :disabled="preview"
                  :error="error"
                  @blur="touch"
                />
              </InputWrap>

              <InputWrap
                class="form__col-4"
                :label="translate('Sukunimi')"
                :validations="safeVIter(i).LastName"
                v-slot="{error, touch}"
              >
                <InputText
                  v-model="item.LastName"
                  :disabled="preview"
                  :error="error"
                  @blur="touch"
                />
              </InputWrap>

              <InputWrap
                class="form__col-4"
                :label="translate('Henkilötunnus')"
                :validations="safeVIter(i).Ssn"
                v-slot="{error, touch}"
              >
                <InputText
                  v-model="item.Ssn"
                  :disabled="preview"
                  :error="error"
                  @blur="touch"
                />
              </InputWrap>
            </div>
          </div>
        </div>
      </template>
    </ApplicationAddable>
  </div>
  </div>
</template>

<script>
  import utils from '../mixins/utils';
  import ApplicationAddable from './ApplicationAddable';
  import ApplicationSection from './ApplicationSection';
  import ApplicationDivider from './ApplicationDivider';
  import InputWrap from './InputWrap';
  import InputText from './InputText';

  export default {
    components: {
      ApplicationSection,
      ApplicationAddable,
      ApplicationDivider,
      InputWrap,
      InputText,
    },
    mixins: [
      utils.translate,
      utils.safeVIter,
    ],
    props: {
      vIter: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      preview: {
        type: Boolean,
        required: true,
      },
    },
    computed: {
      empty() {
        // Guard against vIter being null or undefined
        if (!this.vIter) return true;
        return Object.keys(this.vIter).length === 0;
      }
    }
  }
</script>

<style lang="scss">
  @import "~styles/definitions";

  .application-residents {
  }

  .application-residents__title {
    @include font-h-22;
    margin-bottom: r(32);
  }
</style>
